define(["jquery"], function ($) {
  class Ga4Event {
    constructor() {
      this.bindHomeElementClickEvent();
      this.bindMegaMenuClickEvent();
      this.bind404PageLoadEvent();
      this.bindBlogElementClickEvent();
      this.storeRegionMappings();
      this.bindPbButtonClickEvent();
    }

    bindHomeElementClickEvent() {
      const homeWrapper = document.getElementsByClassName("cms-home");
      const isHome = homeWrapper?.length > 0;

      if (isHome) {
        const clickableElement = homeWrapper[0]
          .getElementsByClassName("columns")[0]
          .querySelectorAll("a[href]");

        clickableElement.forEach((element) => {
          element.addEventListener("click", () => {
            this.onHomeElementClicked(element);
          });
        });
      }
    }

    onHomeElementClicked(element) {
      window.dataLayer.push({
        event: "home_page_interaction",
        url: element.getAttribute("href"),
        title: element.getAttribute("title"), // Some element doesn't have title property
      });
    }

    bindBlogElementClickEvent() {
      const blogWrapper = document.getElementsByClassName(
        "aw_blog-category-view",
      );

      const blogWrapperIndex = document.getElementsByClassName(
        "aw_blog-index-index",
      );

      const isBlogPage =
        blogWrapper?.length > 0 || blogWrapperIndex?.length > 0;
      const wrapper =
        blogWrapperIndex?.length > 0 ? blogWrapperIndex : blogWrapper;

      if (isBlogPage) {
        const clickableElement = wrapper[0]
          .getElementsByClassName("page-main")[0]
          .querySelectorAll("a[href]");

        clickableElement.forEach((element) => {
          element.addEventListener("click", () => {
            this.onBlogElementClicked(element);
          });
        });
      }
    }

    onBlogElementClicked(element) {
      const altImg = element.querySelectorAll("img");
      const title = altImg.length > 0 ? altImg[0].title : element.innerText;
      const url = element.getAttribute("href");

      window.dataLayer.push({
        event: "blog_interaction",
        url,
        title,
      });
    }

    bindMegaMenuClickEvent() {
      const clickableElement = document
        .getElementsByClassName("nav-menu-list")[0]
        .querySelectorAll("a[href]");

      clickableElement.forEach((element) => {
        element.addEventListener("click", () => {
          this.onMegaMenuClicked(element);
        });
      });
    }

    bind404PageLoadEvent() {
      const has404 =
        $("#maincontent > .columns > .main").find(".error-404").length > 0;
      window.dataLayer = Array.isArray(window.dataLayer)
        ? window.dataLayer
        : [];

      if (has404) {
        window.dataLayer.push({
          event: "page_404",
          url: window.location.href,
        });
      }
    }

    onMegaMenuClicked(element) {
      const isSpanElementAvailable = element.querySelector("span");
      let innerText = isSpanElementAvailable
        ? element.querySelector("span").innerText
        : element.innerText;

      window.dataLayer.push({
        event: "mega_menu_interaction",
        url: element.getAttribute("href"),
        name: innerText,
      });
    }

    storeRegionMappings() {
      const regionData = localStorage.getItem("au-regions");
      if (!regionData) {
        $.get("/checkout/cart/regions?country_code=au", function (data) {
          const regions = data.regions;
          localStorage.setItem("au-regions", JSON.stringify(regions));
        });
      }
    }

    bindPbButtonClickEvent() {
      // Original page builder buttons
      this.callSEOButtonClickMethod([...document.getElementsByClassName(
        "pb-buttonlist__item",
      )]);

      // Customised desktop page builder buttons
      this.callSEOButtonClickMethod([...document.getElementsByClassName(
        "desktopbuttons",
      )]);

      // Customised mobile page builder buttons
      this.callSEOButtonClickMethod([...document.getElementsByClassName(
        "mobilebuttons",
      )]);
    }

    callSEOButtonClickMethod(elements) {
      elements.forEach((element) => {
        element.addEventListener("click", () => {
          this.menuButtonClicked(element);
        });
      });
    }

    menuButtonClicked(element) {
      window.dataLayer = Array.isArray(window.dataLayer)
        ? window.dataLayer
        : [];

      const childElement = element.querySelector("a");
      const linkUrl = childElement ? childElement.href : "";
      const childSpan = childElement.querySelector("span");
      const linkName = childSpan ? childSpan.textContent : "";

      window.dataLayer.push({
        event: "seo_link_interaction",
        seo_link_page: window.location.href,
        seo_link_url: linkUrl,
        seo_link_name: linkName,
      });
    }
  }

  let instance = null;

  Ga4Event.singleton = function () {
    if (!instance) {
      instance = new Ga4Event();
    }
    return instance;
  };

  return Ga4Event.singleton();
});
